import { FileDown, FileText, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "../site/Motion";
import { useRfq } from "../site/RfqContext";
import { useSettings, fileUrl } from "../../lib/api";

const DocCard = ({ title, desc, url, testId, i }) => {
  const { open } = useRfq();
  const inner = (
    <>
      <div className="flex items-start justify-between">
        <FileText className="h-10 w-10 text-sky-400" strokeWidth={1.2} />
        <span className="font-mono-x text-[10px] uppercase tracking-widest text-slate-400">PDF · 0{i + 1}</span>
      </div>
      <div>
        <h3 className="font-display text-4xl font-extrabold uppercase leading-none text-white">{title}</h3>
        <p className="mt-3 text-sm text-slate-300">{desc}</p>
        <span className="mt-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-sky-400">
          {url ? <>Download <FileDown className="h-4 w-4" /></> : <>Request a copy <ArrowRight className="h-4 w-4" /></>}
        </span>
      </div>
    </>
  );
  const cls = "clip-corner group flex min-h-[300px] flex-col justify-between border border-slate-800 bg-[#0d121b] p-8 text-left transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-[#121a27] w-full";
  return (
    <Reveal delay={i * 0.1}>
      {url ? (
        <a data-testid={testId} href={fileUrl(url)} target="_blank" rel="noreferrer" className={cls}>{inner}</a>
      ) : (
        <button data-testid={testId} onClick={() => open(`${title} (PDF)`)} className={cls}>{inner}</button>
      )}
    </Reveal>
  );
};

export const Downloads = () => {
  const s = useSettings();
  return (
    <section id="downloads" data-testid="downloads-section" className="relative bg-[#07090e] py-24 md:py-32">
      <div className="container-x grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHead dark eyebrow="05 — Downloads" title="Take the specs with you.">
            Share our company profile and product catalogue with your sourcing and engineering teams.
          </SectionHead>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
          <DocCard i={0} testId="download-company-profile-button" title="Company profile" desc="Story, capabilities, infrastructure and key clients." url={s.company_profile_pdf} />
          <DocCard i={1} testId="download-catalog-button" title="Product catalogue" desc="All product families with materials and applications." url={s.catalog_pdf} />
        </div>
      </div>
    </section>
  );
};
